/// <amd-module name="Wit/WorkItemSignalR/WorkItemSignalRService" />
import { IHubHostInformation } from "VSS/Features/SignalR/Hub";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssHistoryService } from "VSS/Platform/History";
import { IVssPageService } from "VSS/Platform/Page";
import { traceException } from "VSS/Platform/Trace";
import { IWorkItemSignalRService, IWorkItemUpdatePayload } from "Wit/WorkItemSignalRTypes/WorkItemSignalRService.Types";
import { ISignalROptions, WorkItemHub } from "./WorkItemSignalRHub";

class WorkItemService extends VssService implements IWorkItemSignalRService {
    private _workItemHub: WorkItemHub | null;

    public _serviceEnd(pageContext: IVssPageContext): void {
        super._serviceEnd(pageContext);
        if (this._workItemHub) {
            this._workItemHub.dispose();
        }
        this._workItemHub = null;
    }

    public async watch(
        workItemId: number,
        onWorkItemUpdated: (workItemUpdatePayload: IWorkItemUpdatePayload) => void,
        useSignalRAppPoolDefaultValue?: boolean
    ): Promise<void> {
        this._ensureHubInitialized(useSignalRAppPoolDefaultValue);

        if (this._workItemHub && workItemId) {
            try {
                await this._workItemHub.watch(workItemId, onWorkItemUpdated);
            } catch (error) {
                traceException(this.pageContext, "WIT", "WorkItem", error, { ["method"]: "SignalR.Watch" });
            }
        }
    }

    public async endWatch(workItemId: number): Promise<void> {
        if (this._workItemHub) {
            try {
                await this._workItemHub.endWatch(workItemId);
            } catch (error) {
                traceException(this.pageContext, "WIT", "WorkItem", error, { ["method"]: "SignalR.EndWatch" });
            }
        }
    }

    private _ensureHubInitialized(useSignalRAppPoolDefaultValue?: boolean) {
        if (!this._workItemHub) {
            const vssPageService = this.pageContext.getService<IVssPageService>("IVssPageService");
            const vssPageData = vssPageService.getData();
            const historyService = this.pageContext.getService<IVssHistoryService>("IVssHistoryService");

            if (vssPageData) {
                const hostInformation: IHubHostInformation = {
                    hostId: vssPageData.hostId,
                    hostPath: vssPageData.hostPath,
                    isHosted: vssPageData.isHosted
                };
                const options: ISignalROptions = {
                    hostInformation: hostInformation,
                    historyService: historyService,
                    pageContext: this.pageContext,
                    useSignalRAppPoolDefaultValue
                };
                this._workItemHub = new WorkItemHub(options);
            }
        }
    }
}

Services.add("ms.vss-work-web.work-item-signalr-service", { serviceFactory: WorkItemService });
